import * as React from 'react';
import { Dropdown, DropdownMenuItemType} from '@fluentui/react/lib/Dropdown';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Checkbox } from '@fluentui/react/lib/Checkbox';
import { Label } from '@fluentui/react/lib/Label';
import AsyncSelect from 'react-select/async';
import { LogError } from '../actions/errorWorker';
import { entity_quick_search } from '../actions/entityWorker';
import { throwError,  ExistingCheck, toggleLoading, summaryScreen } from '../actions/navigationWorker';
import { getEntityTypes, getEntityTypeText, EntityTypesMap } from '../actions/helper';
import { DayOfWeek } from '@fluentui/react';
import NoteProperties from './NoteProperties';
import NewTaskProperties from './NewTaskProperties';
import ActiveTaskProperties from './ActiveTaskProperties';
import FiledNoteProperties from './FiledNoteProperties';


let entityStatus = [];
export interface AppProps {
   hide: boolean;
}

export interface AppState {
    selected: any,
    toggleClientOnlyFields: any,
    selectedEntities: any[],
    selectedEntityStatus: any,
    selectedEntityType: string,
    firstDayOfWeek?: DayOfWeek,
    selectedFileTo: string,
    activeTaskData: any,
    filedNoteData: any,
    excludeEmailFromNote: boolean,
    customNoteBody: string
}

class EntitySelection extends React.Component<AppProps, AppState> {
    private originalScrollIntoView: any;

    constructor(props) {
        super(props);
        let default_client_status = localStorage.getItem('entity_entity_client_status_default');
        let default_client_status_array = !default_client_status ? [] : default_client_status.split(',').map(Number);
        
        // Read file_to_type from sessionStorage if it exists
        let storedFileToType = 'note'; // default
        try {
            const stored = sessionStorage.getItem('file_to_type');
            if (stored) {
                const parsed = JSON.parse(stored);
                if (parsed && parsed.id) {
                    storedFileToType = parsed.id;
                }
            }
        } catch (e) {
            // Failed to parse, using default
        }
        
        // Load selected clients from sessionStorage if they exist
        let selectedEntitiesFromStorage = [];
        try {
            const storedClients = sessionStorage.getItem('selected_clients');
            if (storedClients) {
                const parsed = JSON.parse(storedClients);
                if (parsed && Array.isArray(parsed)) {
                    // Convert from storage format {id, name} to AsyncSelect format {value, label, entity_name}
                    selectedEntitiesFromStorage = parsed.map(client => ({
                        value: client.id,
                        label: client.name,
                        entity_name: client.name
                    }));
                }
            }
        } catch (e) {
            // Failed to parse, using default
        }
        
        this.state = {
            selected: {},
            toggleClientOnlyFields: true,
            selectedEntities: selectedEntitiesFromStorage,
            selectedEntityStatus: default_client_status_array,
            selectedEntityType: 'client-v2',
            firstDayOfWeek: DayOfWeek.Sunday,
            selectedFileTo: storedFileToType,
            activeTaskData: null,
            filedNoteData: null,
            excludeEmailFromNote: sessionStorage.getItem("exclude_email_from_note") === "true",
            customNoteBody: sessionStorage.getItem("custom_note_body") || ""
        };
        this.handleEntityTypeChange = this.handleEntityTypeChange.bind(this);
        this.handleEntitySelectionChange = this.handleEntitySelectionChange.bind(this);
        this.handleSelectedEntityStatus = this.handleSelectedEntityStatus.bind(this);
        this.entitySearch = this.entitySearch.bind(this);
        this.handleExcludeEmailChange = this.handleExcludeEmailChange.bind(this);
        this.handleCustomNoteBodyChange = this.handleCustomNoteBodyChange.bind(this);
        this.getEntityStatus();
        
        // Disable auto-scroll on hover in dropdowns by overriding scrollIntoView
        this.disableAutoScrollInDropdowns();
        
        // Prevent focus changes on hover
        this.preventDropdownFocusOnHover();
    }

    preventDropdownFocusOnHover = () => {
        // Add event listener to prevent focus on hover in dropdowns
        document.addEventListener('mousemove', (e) => {
            const target = e.target as HTMLElement;
            if (target && typeof target.closest === 'function') {
                const dropdownItem = target.closest('.ms-Dropdown-item');
                if (dropdownItem) {
                    // Prevent focus by stopping the event
                    e.stopPropagation();
                    // Remove focus from the item if it has it
                    const focusedElement = document.activeElement as HTMLElement;
                    if (focusedElement && focusedElement.closest('.ms-Dropdown-item')) {
                        focusedElement.blur();
                    }
                }
            }
        }, true);
    }

    disableAutoScrollInDropdowns = () => {
        // Save original scrollIntoView
        this.originalScrollIntoView = Element.prototype.scrollIntoView;
        
        // Override scrollIntoView to prevent auto-scrolling on hover
        Element.prototype.scrollIntoView = function(arg?: any) {
            // Check if element is inside a dropdown or callout
            if (this.closest) {
                const inDropdown = this.closest('.ms-Dropdown-items') || 
                                 this.closest('.ms-Dropdown-itemsWrapper') ||
                                 this.closest('.ms-Callout-main') ||
                                 this.closest('.ms-Dropdown-callout') ||
                                 this.classList?.contains('ms-Dropdown-item');
                
                if (inDropdown) {
                    // Block ALL scrollIntoView calls inside dropdowns
                    return;
                }
            }
            // Allow scrollIntoView for other cases
            return this.originalScrollIntoView.call(this, arg);
        };
    }

    restoreScrollIntoView = () => {
        if (this.originalScrollIntoView) {
            Element.prototype.scrollIntoView = this.originalScrollIntoView;
        }
    }

    componentDidMount() {
        if (!sessionStorage.getItem('selected_entity_type')){
            this.handleEntityTypeChange(null, {key: 'client-v2', text: 'Client'});
        }
        else{
            this.handleEntityTypeChange(null, {key: EntityTypesMap(sessionStorage.getItem('selected_entity_type')), text: ''});
        }
        
        // Ensure file_to_type is set in sessionStorage
        if (!sessionStorage.getItem('file_to_type')) {
            sessionStorage.setItem('file_to_type', JSON.stringify({ id: this.state.selectedFileTo, name: 'Note' }));
        }
    }

    componentWillUnmount() {
        // Restore original scrollIntoView behavior
        this.restoreScrollIntoView();
    }

    handleEntityTypeChange = (_event, item) => {
        let client_only_fields = true;
        let selected_entity_type = item.key;

        if (item.key === 'client-v2') {
            client_only_fields = false;
            selected_entity_type = 'client';
        } else if (item.key === 'referrer') {
            selected_entity_type = 'referral';
        }

        sessionStorage.setItem('selected_entity_type', selected_entity_type);
        this.setState({
            toggleClientOnlyFields: client_only_fields,
            selectedEntityType: item.key
        });
    }

    handleEntitySelectionChange = async (selectedOptions) => {
        await new Promise<void>(resolve => {
            this.setState({ selectedEntities: selectedOptions || [] }, () => resolve());
        });
        
        // Auto-save to session storage
        if (selectedOptions && selectedOptions.length > 0) {
            const selectedForStorage = selectedOptions.map(entity => ({
                id: entity.value,
                name: entity.entity_name
            }));
            sessionStorage.setItem('selected_clients', JSON.stringify(selectedForStorage));
            
            // If active tasks is selected and we have entities, load the tasks
            if (this.state.selectedFileTo === 'activetask') {
                await this.loadActiveTasks();
            } else if (this.state.selectedFileTo === 'existingnote') {
                await this.loadFiledNotes();
            }
        } else {
            // Clear tasks when entity field is cleared
            if (this.state.selectedFileTo === 'activetask') {
                this.setState({ activeTaskData: null });
            }
            if (this.state.selectedFileTo === 'existingnote') {
                this.setState({ filedNoteData: null });
            }
            sessionStorage.removeItem('selected_clients');
        }
    }

    handleFileToTypeChange = async (_event, item) => {
        const newFileTo = item.key;
        this.setState({ selectedFileTo: newFileTo });
        sessionStorage.setItem('file_to_type', JSON.stringify({ id: item.key, name: item.text }));
        
        // Load active tasks if that option is selected and entities are already selected
        if (newFileTo === 'activetask' && this.state.selectedEntities.length > 0) {
            await this.loadActiveTasks();
        } else if (newFileTo === 'existingnote' && this.state.selectedEntities.length > 0) {
            await this.loadFiledNotes();
        } 
        
        if (newFileTo !== 'activetask') {
            // Clear active task data when switching away from active tasks
            this.setState({ activeTaskData: null });
        }
        if (newFileTo !== 'existingnote') {
            this.setState({ filedNoteData: null });
        }
    }

    handleExcludeEmailChange = (_event, checked: boolean) => {
        this.setState({ excludeEmailFromNote: checked });
        sessionStorage.setItem("exclude_email_from_note", checked ? "true" : "false");
        
        // If unchecking, reload the subject from the email and clear custom body
        if (!checked && Office.context.mailbox && Office.context.mailbox.item) {
            const emailSubject = Office.context.mailbox.item.subject.replace(/[*|?:"<>\\\/]/gi, ' ');
            sessionStorage.setItem('subject', emailSubject);
            // Trigger a reload of the subject in NoteProperties
            sessionStorage.setItem('reload_subject_from_email', 'true');
            // Clear custom note body
            this.setState({ customNoteBody: '' });
            sessionStorage.removeItem('custom_note_body');
        }
    }

    handleCustomNoteBodyChange = (_event, value: string) => {
        this.setState({ customNoteBody: value });
        sessionStorage.setItem('custom_note_body', value);
    }

    loadActiveTasks = async () => {
        const selected_clients = this.state.selectedEntities.map(e => ({
            id: e.value,
            name: e.entity_name
        }));
        
        if (selected_clients?.length > 1) {
            throwError("Filing to multiple entities on active tasks is not permitted.");
            this.setState({ selectedFileTo: 'note' });
            return;
        }

        if (selected_clients?.length === 0) {
            return;
        }
        
        try {
            const { getXplanURL, APICalls, getPayload, handleResponseData } = require('../actions/helper');
            const axios = require('axios');
            
            const data = [];
            for (let i = 0; i < selected_clients.length; i++) {
                const entity_ids = "&entity_ids.0=" + selected_clients[i]["id"];
                const payload = getPayload(
                    getXplanURL() + APICalls.ActiveTasks.replace("{2}", entity_ids),
                    null,
                    "GET"
                );

                const response = await axios.post(APICalls.AWSUrl(), payload);
                const result_data = handleResponseData(
                    response,
                    "No Active Task found for this client",
                    true
                );

                const isError = result_data && result_data.isError;
                if (isError) {
                    throw result_data.message;
                }

                if (result_data) data.push(...result_data);
            }
            
            if (data.length) {
                this.processActiveTaskData(data);
            } else {
                this.setState({ activeTaskData: [] });
            }
        } catch (error) {
            throwError(error.toString());
            LogError(error, {}, "loadActiveTasks", "ERROR");
            this.setState({ selectedFileTo: 'note' });
        }
    }

    processActiveTaskData = (data) => {
        let task_assignee_params = "";
        const task_assignee_list = [];
        let counter = 0;

        for (let item_count = 0; item_count < data.length; item_count++) {
            const task_assignee_id = data[item_count]["assignee"];
            if (task_assignee_list.indexOf(task_assignee_id) < 0) {
                task_assignee_params = task_assignee_params + "&ids." + counter + "=" + task_assignee_id;
                task_assignee_list.push(task_assignee_id);
                counter = counter + 1;
            }
        }
        this.getAdviserDetails(task_assignee_params, data);
    }

    loadFiledNotes = async () => {
        const selected_clients = JSON.parse(sessionStorage.getItem("selected_clients")) || [];
        
        if (selected_clients?.length > 1) {
            throwError("Filing to multiple entities on filed notes is not permitted.");
            this.setState({ selectedFileTo: 'note' });
            return;
        }

        if (selected_clients?.length === 0) {
            // No client selected, clear data
            this.setState({ filedNoteData: null });
            return;
        }

        toggleLoading(true);
        
        try {
            const { getXplanURL, APICalls, getPayload, handleResponseData } = require('../actions/helper');
            const axios = require('axios');
            
            const data = [];
            for (let i = 0; i < selected_clients.length; i++) {
                const entity_ids = "&entity_ids.0=" + selected_clients[i]["id"];
                const payload = getPayload(
                    getXplanURL() + APICalls.FiledNotes.replace("{2}", entity_ids),
                    null,
                    "GET"
                );

                const response = await axios.post(APICalls.AWSUrl(), payload);
                const result_data = handleResponseData(
                    response,
                    "No Filed Notes found for this client",
                    true
                );

                const isError = result_data && result_data.isError;
                if (isError) {
                    throw result_data.message;
                }

                if (result_data) data.push(...result_data);
            }

            if (data.length) {
                this.processFiledNoteData(data);
            } else {
                this.setState({ filedNoteData: [] });
                toggleLoading(false);
            }
        } catch (error) {
            throwError(error.toString());
            LogError(error, {}, "loadFiledNotes", "ERROR");
            this.setState({ selectedFileTo: 'note' });
            toggleLoading(false);
        }
    }

    processFiledNoteData = (data) => {
        const items = [];
        try {
            for (let item_count = 0; item_count < data.length; item_count++) {
                const note_date_raw =
                    data[item_count]["reference_date"]?._val ||
                    data[item_count]["note_date"]?._val ||
                    data[item_count]["created_date"]?._val ||
                    data[item_count]["date"]?._val ||
                    data[item_count]["reference_date"] ||
                    data[item_count]["note_date"] ||
                    data[item_count]["created_date"] ||
                    data[item_count]["date"];
                const note_date = note_date_raw ? String(note_date_raw).substring(0, 10) : "";
                
                const note_subject = data[item_count]["subject"] || "";
                const note_type = data[item_count]["doctype"] || "";
                const note_subtype = data[item_count]["docsubtype"] || "";
                const note_id = data[item_count]["id"] || data[item_count]["docid"] || data[item_count]["doc_id"];
                if (!note_id) {
                    continue;
                }

                const details = `Subject: ${note_subject}|break|Type: ${note_type}|break|Subtype: ${note_subtype}|break|Date: ${note_date}`;

                const fieldRow = {
                    id: note_id,
                    subject: note_subject,
                    details: details
                };
                items.push(fieldRow);
            }

            this.setState({ filedNoteData: items });
            toggleLoading(false);
        } catch (error) {
            throwError(error.toString());
            LogError(error, {}, "processFiledNoteData", "ERROR");
            toggleLoading(false);
        }
    }

    getAdviserDetails = async (entity_ids, task_data) => {
        const { getXplanURL, APICalls, getPayload, handleResponseData } = require('../actions/helper');
        const axios = require('axios');
        
        const items = [];
        const taskkind_lookup = JSON.parse(localStorage.getItem("task_taskkind_results")) || [];
        const subtype_lookup = JSON.parse(localStorage.getItem("task_subtype_results")) || [];

        try {
            const payload = getPayload(getXplanURL() + APICalls.AdviserSearch + entity_ids, null, "GET");
            const response = await axios.post(APICalls.AWSUrl(), payload);
            const adviser_data = handleResponseData(response, "");
            const clients = this.state.selectedEntities.map(e => ({ id: e.value, name: e.entity_name }));
            
            for (let item_count = 0; item_count < task_data.length; item_count++) {
                let task_due_date = task_data[item_count]["duedate"];
                task_due_date = task_due_date ? task_due_date._val : "";

                const task_type_id = task_data[item_count]["taskkind"];
                const task_subtype_id = task_data[item_count]["subtype"];
                const task_assignee_id = task_data[item_count]["assignee"];

                let task_type = taskkind_lookup.find((element) => element[0] === task_type_id);
                if (task_type) task_type = task_type[1];
                
                let task_subtype = subtype_lookup.find((element) => element[0] === task_subtype_id);
                if (task_subtype) task_subtype = task_subtype[1];
                
                let task_assignee;
                if (adviser_data) {
                    task_assignee = adviser_data.find((element) => element.id === task_assignee_id);
                    if (task_assignee) task_assignee = task_assignee.entity_name;
                }

                const task_subject = task_data[item_count]["subject"];
                const task_id = task_data[item_count]["id"];
                const entity = clients.find((x) => x.id === task_data[item_count]["client"]);
                const entityName = entity ? entity.name : "";
                
                const fieldRow = {
                    id: task_id,
                    subject: task_subject,
                    type: task_type,
                    subtype: task_subtype,
                    due_date: task_due_date,
                    assignee: task_assignee,
                    name: entityName,
                    details:
                        entityName +
                        "|break|Task ID: " +
                        task_id +
                        "|break|Subject: " +
                        task_subject +
                        "|break|Type: " +
                        task_type +
                        " > " +
                        task_subtype +
                        "|break|Due Date: " +
                        task_due_date +
                        "|break|Assignee: " +
                        task_assignee,
                };
                items.push(fieldRow);
            }

            this.setState({ activeTaskData: items });
            toggleLoading(false);
        } catch (error) {
            throwError(error.toString());
            LogError(error, {}, "getAdviserDetails", "ERROR");
            toggleLoading(false);
        }
    }

    entitySearch = async (query: string): Promise<any[]> => {
        // Return empty array if less than 3 characters
        if (query.length < 3) {
            return [];
        }

        try {
            const searchCriteria: any = { entityName: query };

            const results = await entity_quick_search(
                searchCriteria,
                this.state.selectedEntityType,
                this.state.selectedEntityStatus
            );

            return this.formatEntityData(results);
        } catch (error) {
            LogError(error, {}, 'entitySearch', 'ERROR');
            return [];
        }
    }

    formatEntityData = (data: any[]): any[] => {
        if (!data || data.length === 0) {
            return [];
        }

        return data.map(entity => {
            let label = entity.entity_name || '';

            // Add additional info for clients
            if (this.state.selectedEntityType === 'client-v2' && entity.fields) {
                const dob = entity.fields.dob ? entity.fields.dob._val || entity.fields.dob : '';
                const adviser = entity.fields.client_adviser_name || '';
                
                if (dob) {
                    label += ` (DOB: ${dob})`;
                }
                if (adviser) {
                    label += ` Adviser: ${adviser}`;
                }
            }

            return {
                value: entity.entity_id || entity.id,
                label: label,
                entity_name: entity.entity_name
            };
        });
    }

    handleNextClick = async () => {
        if (this.state.selectedEntities.length === 0) {
            throwError("Please select at least one entity");
            return;
        }

        // Small delay to ensure any pending onChange/onBlur events complete
        await new Promise(resolve => setTimeout(resolve, 100));

        // Validate mandatory fields based on file type
        if (this.state.selectedFileTo === 'note') {
            // Validate Subject
            const subject = sessionStorage.getItem('subject');
            if (!subject || subject.trim() === '') {
                throwError("Note Subject is required. Please enter a subject.");
                return;
            }

            // Validate Document Type
            const docType = JSON.parse(sessionStorage.getItem('doc_type') || 'null');
            if (!docType || !docType.id || docType.id === 'not_selected') {
                throwError("Note Type is required. Please select a Document Type.");
                return;
            }

            // Validate Permission
            const docPermission = JSON.parse(sessionStorage.getItem('doc_permission') || 'null');
            if (!docPermission || !docPermission.name) {
                throwError("Permission is required. Please select a Note Permission.");
                return;
            }

            // Validate custom note body is not empty when excluding email
            const excludeEmail = sessionStorage.getItem("exclude_email_from_note") === "true";
            const customNoteBody = sessionStorage.getItem("custom_note_body") || "";
            if (excludeEmail && (!customNoteBody || customNoteBody.trim() === '')) {
                throwError("Please enter note body content when excluding email from note");
                return;
            }
        } else if (this.state.selectedFileTo === 'newtask') {
            // Validate Task Type
            const taskType = JSON.parse(sessionStorage.getItem('task_type') || 'null');
            if (!taskType || !taskType.id) {
                throwError("Task Type is required. Please select a Task Type.");
                return;
            }

            // Validate Task Subject
            const subject = sessionStorage.getItem('subject');
            if (!subject || subject.trim() === '') {
                throwError("Task Subject is required. Please enter a subject.");
                return;
            }
        } else if (this.state.selectedFileTo === 'activetask') {
            // Validate Active Task Selection
            const activeTasks = JSON.parse(sessionStorage.getItem('selected_active_tasks') || '[]');
            if (!activeTasks || activeTasks.length === 0) {
                throwError("Please select at least one active task to file to.");
                return;
            }
        } else if (this.state.selectedFileTo === 'existingnote') {
            // Validate Filed Note Selection
            const filedNotes = JSON.parse(sessionStorage.getItem('selected_filed_notes') || '[]');
            if (!filedNotes || filedNotes.length === 0) {
                throwError("Please select at least one existing note to file to.");
                return;
            }
        }

        // Format selected entities for session storage
        const selectedForStorage = this.state.selectedEntities.map(entity => ({
            id: entity.value,
            name: entity.entity_name
        }));

        sessionStorage.setItem('selected_clients', JSON.stringify(selectedForStorage));
        
        // Navigate to summary screen to show final confirmation before filing
        summaryScreen();
    }



    back_to_start = () => {
        ExistingCheck();
    }

    _onFormatDate = (date?: Date | null): string => {
        let return_date = '';
        if (date) {
            return_date =  (('0' + (date.getDate())).slice(-2)).toString() + '/' +
                (('0' + (date.getMonth() + 1)).slice(-2)).toString() + '/' +
                date.getFullYear().toString();
        }
        return return_date;
    }

    _onParseDateFromString = (value: string): Date => {
        const date = new Date();
        const values = (value || '').trim().split('/');
        const day = values.length > 0 ? Math.max(1, Math.min(31, parseInt(values[0], 10))) : date.getDate();
        const month = values.length > 1 ? Math.max(1, Math.min(12, parseInt(values[1], 10))) - 1 : date.getMonth();
        let year = values.length > 2 ? parseInt(values[2], 10) : date.getFullYear();
        if (year < 100) {
          year += date.getFullYear() - (date.getFullYear() % 100);
        }
        return new Date(year, month, day);
    }

    handleSelectedEntityStatus = (_event, item) => {
        const updatedSelectedItem = this.state.selectedEntityStatus ? this.copyArray(this.state.selectedEntityStatus) : [];

        if (item.selected) {
            updatedSelectedItem.push(item.key);
        }
        else {
            // remove the option if it's unchecked
            const currIndex = updatedSelectedItem.indexOf(item.key);
            if (currIndex > -1) {
                updatedSelectedItem.splice(currIndex, 1);
            }
        }
        this.setState({selectedEntityStatus: updatedSelectedItem });
    }

    public copyArray = (array: any[]): any[] => {
        const newArray: any[] = [];
        for (let i = 0; i < array.length; i++) {
            newArray[i] = array[i];
        }
        return newArray;
    }

    validate_criteria = () => {
        let error_message = '';
        return error_message;
    }

    getEntityStatus = () => {
        let data: any;
        entityStatus = [{ key: 'Header', text: 'Entity Status', itemType: DropdownMenuItemType.Header }];

        data = JSON.parse(localStorage.getItem('entity_entity_client_status_results')) || [];
        if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                entityStatus.push({ key: data[i][0], text: data[i][1], itemType: DropdownMenuItemType.Normal });
            }
        } else if (localStorage.getItem("ufields_need_loading") === "true") {
            // Data is still loading
            entityStatus.push({ key: 'loading', text: 'Loading options...', itemType: DropdownMenuItemType.Normal });
        }
    }

    public render() {
        const container = document.getElementById('MainBody');
        if (container) {
            container.style.backgroundImage = '';
            container.style.backgroundColor = '#ffffff';
        }

        const style = this.state.toggleClientOnlyFields ? { display: 'none', marginTop: '5px' } : {marginTop: '5px'};
        return (
            <div style={{ 
                fontSize: '13px', 
                display: 'flex', 
                flexDirection: 'column', 
                position: 'fixed',
                top: '45px',
                left: 0,
                right: 0,
                bottom: 0,
                width: '100%',
                height: 'calc(100% - 45px)',
                overflow: 'hidden'
            }}>
                {/* Scrollable Content Area */}
                <div style={{ 
                    flex: 1, 
                    overflowY: 'auto', 
                    overflowX: 'hidden',
                    padding: '4px',
                    paddingBottom: '8px',
                    WebkitOverflowScrolling: 'touch'
                }}>
                <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    padding: '8px',
                    marginBottom: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    border: '2px solid #5D3FD6'
                }}>
                    <h3 style={{ 
                        marginTop: 0, 
                        marginBottom: '6px', 
                        fontSize: '14px',
                        color: '#1A1F4D',
                        fontWeight: 600
                    }}>
                        Search Criteria
                    </h3>
                    
                    {/* Filing Option Dropdown - at the top */}
                    <div style={{ marginBottom: '4px' }}>
                        <Dropdown
                            label='* Filing Option'
                            selectedKey={this.state.selectedFileTo}
                            onChange={this.handleFileToTypeChange}
                            placeholder='Select Filing Option'
                            options={[
                                { key: 'note', text: 'Note' },
                                { key: 'existingnote', text: 'Existing Notes' },
                                { key: 'newtask', text: 'Task' },
                                { key: 'activetask', text: 'Active Tasks' }
                            ]}
                            calloutProps={{ 
                                calloutMaxHeight: 400,
                                doNotLayer: false,
                                calloutMinWidth: 300,
                                directionalHint: 6,
                                alignTargetEdge: true,
                                isBeakVisible: false
                            }}
                            dropdownWidth="auto"
                            responsiveMode={999}
                            styles={{
                                root: { marginBottom: '4px' },
                                label: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' },
                                title: { fontSize: '13px', height: '32px', lineHeight: '28px', borderColor: '#5D3FD6', borderRadius: '6px' },
                                callout: {
                                    maxHeight: '60vh',
                                    minWidth: '300px',
                                    width: 'auto',
                                    left: '0 !important',
                                    selectors: {
                                        '.ms-Callout-main': {
                                            maxHeight: '60vh',
                                            minWidth: '300px',
                                            overflow: 'visible'
                                        }
                                    }
                                },
                                dropdownItemsWrapper: {
                                    maxHeight: '50vh',
                                    minWidth: '300px'
                                },
                                dropdownItems: {
                                    minWidth: '300px'
                                },
                                dropdownItem: {
                                    minWidth: '300px',
                                    whiteSpace: 'normal',
                                    height: 'auto',
                                    lineHeight: '20px',
                                    padding: '8px',
                                    fontSize: '13px'
                                },
                                dropdownItemSelected: {
                                    minWidth: '300px',
                                    fontSize: '13px'
                                }
                            }}
                        />
                        {this.state.selectedFileTo === 'note' && (
                            <div style={{ 
                                marginTop: '4px', 
                                marginBottom: '4px',
                                padding: '8px',
                                border: '1px solid #5D3FD6',
                                borderRadius: '6px',
                                backgroundColor: '#f9f8fc'
                            }}>
                                <Checkbox
                                    label="Exclude email from note"
                                    checked={this.state.excludeEmailFromNote}
                                    onChange={this.handleExcludeEmailChange}
                                    styles={{
                                        root: { marginTop: '0' },
                                        text: { 
                                            fontSize: '13px',
                                            fontWeight: 500,
                                            color: '#1A1F4D'
                                        },
                                        checkbox: {
                                            borderColor: '#5D3FD6',
                                            borderRadius: '3px'
                                        }
                                    }}
                                />
                            </div>
                        )}
                    </div>

                    <Dropdown
                        label='Entity Type'
                        placeholder='Entity Type'
                        selectedKey={[this.state.selectedEntityType]}
                        options = {getEntityTypes([{ key: 'Header', text: 'Entity Type', itemType: DropdownMenuItemType.Header }])}
                        onChange={this.handleEntityTypeChange}
                        calloutProps={{ 
                            calloutMaxHeight: 400,
                            doNotLayer: false,
                            calloutMinWidth: 300,
                            directionalHint: 6,
                            alignTargetEdge: true,
                            isBeakVisible: false
                        }}
                        dropdownWidth="auto"
                        responsiveMode={999}
                        styles={{
                            root: { marginBottom: '4px' },
                            label: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' },
                            title: { fontSize: '13px', height: '32px', lineHeight: '28px', borderColor: '#5D3FD6', borderRadius: '6px' },
                            callout: {
                                maxHeight: '60vh',
                                minWidth: '300px',
                                width: 'auto',
                                selectors: {
                                    '.ms-Callout-main': {
                                        maxHeight: '60vh',
                                        minWidth: '300px',
                                        overflow: 'visible',
                                        left: '0 !important'
                                    }
                                }
                            },
                            dropdownItemsWrapper: {
                                maxHeight: '50vh',
                                minWidth: '300px'
                            },
                            dropdownItems: {
                                minWidth: '300px'
                            },
                            dropdownItem: {
                                minWidth: '300px',
                                whiteSpace: 'normal',
                                height: 'auto',
                                lineHeight: '20px',
                                padding: '8px',
                                fontSize: '13px'
                            },
                            dropdownItemSelected: {
                                minWidth: '300px',
                                fontSize: '13px'
                            }
                        }}
                    />
                    
                    {/* Entity Status Dropdown */}
                    <div id='divEntityStatus' style={style}>
                        <Dropdown
                            label='Entity Status'
                            placeholder='Entity Status'
                            onChange={this.handleSelectedEntityStatus}
                            multiSelect
                            defaultSelectedKeys={this.state.selectedEntityStatus}
                            options={entityStatus}
                            calloutProps={{ 
                                calloutMaxHeight: 400,
                                doNotLayer: false,
                                calloutMinWidth: 300,
                                directionalHint: 6,
                                alignTargetEdge: true,
                                isBeakVisible: false
                            }}
                            dropdownWidth="auto"
                            responsiveMode={999}
                            styles={{
                                root: { marginBottom: '6px' },
                                label: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' },
                                title: { fontSize: '13px', height: '32px', lineHeight: '28px', borderColor: '#5D3FD6', borderRadius: '6px' },
                                callout: {
                                    maxHeight: '60vh',
                                    minWidth: '300px',
                                    width: 'auto',
                                    left: '0 !important',
                                    selectors: {
                                        '.ms-Callout-main': {
                                            maxHeight: '60vh',
                                            minWidth: '300px',
                                            overflow: 'visible'
                                        }
                                    }
                                },
                                dropdownItemsWrapper: {
                                    maxHeight: '50vh',
                                    minWidth: '300px'
                                },
                                dropdownItems: {
                                    minWidth: '300px'
                                },
                                dropdownItem: {
                                    minWidth: '300px',
                                    whiteSpace: 'normal',
                                    height: 'auto',
                                    lineHeight: '20px',
                                    padding: '8px',
                                    fontSize: '13px'
                                },
                                dropdownItemSelected: {
                                    minWidth: '300px',
                                    fontSize: '13px'
                                }
                            }}
                        />
                    </div>

                    {/* Search Client - moved below Entity Status */}
                    <div id='divName' style={{marginBottom: '4px'}}>
                        <Label styles={{ 
                            root: {
                                display: 'block',
                                fontSize: '12px',
                                fontWeight: 500,
                                color: '#1A1F4D',
                                marginBottom: '3px',
                                padding: 0
                            }
                        }}>
                            * Search Client
                        </Label>
                        <AsyncSelect
                            cacheOptions={false}
                            loadOptions={this.entitySearch}
                            onChange={this.handleEntitySelectionChange}
                            value={this.state.selectedEntities}
                            isMulti
                            placeholder={`Type to search for ${getEntityTypeText(this.state.selectedEntityType)}...`}
                            noOptionsMessage={(obj) => obj.inputValue.length < 3 ? "Type at least 3 characters" : "No results found"}
                            loadingMessage={() => "Searching..."}
                            blurInputOnSelect={true}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '32px',
                                    fontSize: '13px',
                                    borderColor: '#5D3FD6',
                                    borderWidth: '1px',
                                    borderRadius: '6px',
                                    '&:hover': {
                                        borderColor: '#5D3FD6'
                                    }
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 6px'
                                }),
                                menu: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                    fontSize: '13px'
                                }),
                                option: (base) => ({
                                    ...base,
                                    fontSize: '13px'
                                }),
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: '#f0ebf8',
                                    fontSize: '12px',
                                    margin: '1px'
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    fontSize: '12px',
                                    color: '#1A1F4D',
                                    padding: '1px 3px'
                                })
                            }}
                        />
                    </div>
                  
                    {/* Filing Properties - Always visible */}
                    {/* Note Properties */}
                    {this.state.selectedFileTo === 'note' && (
                        <div style={{ marginTop: '8px' }}>
                            <NoteProperties hide={false} />
                        </div>
                    )}

                    {/* Task Properties */}
                    {this.state.selectedFileTo === 'newtask' && (
                        <div style={{ marginTop: '8px' }}>
                            <NewTaskProperties hide={false} data={[]} />
                        </div>
                    )}

                    {/* Existing Note Properties */}
                    {this.state.selectedFileTo === 'existingnote' && (
                        <div style={{ marginTop: '8px' }}>
                            <FiledNoteProperties hide={false} data={this.state.filedNoteData || []}  />
                        </div>
                    )}

                    {/* Active Task Properties */}
                    {this.state.selectedFileTo === 'activetask' && (
                        <div style={{ marginTop: '8px' }}>
                            <ActiveTaskProperties hide={false} data={this.state.activeTaskData || []} />
                        </div>
                    )}
                </div>

                {/* Action Buttons - moved outside scrollable area */}
                </div>
                
                {/* Fixed Button Footer */}
                <div style={{ 
                    flexShrink: 0,
                    padding: '8px 12px 12px 12px',
                    backgroundColor: '#ffffff',
                    borderTop: '2px solid #5D3FD6',
                    boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
                    zIndex: 10
                }}>
                <div style={{ display: 'flex', gap: '12px' }}>
                    <DefaultButton 
                        data-automation-id='btnBack' 
                        text='Filed Notes' 
                        onClick={ this.back_to_start }
                        style={sessionStorage.getItem('hasDocNote') !== '1' ? { display: 'none' } : {}}
                        styles={{
                            root: {
                                flex: 1,
                                height: '36px',
                                border: '2px solid #5D3FD6',
                                borderRadius: '6px'
                            },
                            label: { fontSize: '13px', fontWeight: 500 }
                        }}
                    />
                    <PrimaryButton 
                        data-automation-id='btnFile' 
                        text='File' 
                        onClick={this.handleNextClick}
                        disabled={
                            this.state.selectedFileTo === 'existingnote'
                                ? false // Allow clicking for existingnote, validation happens in handleNextClick
                                : (this.state.selectedEntities.length === 0)
                        }
                        styles={{
                            root: {
                                flex: 1,
                                height: '36px',
                                backgroundColor: '#5D3FD6',
                                border: 'none',
                                borderRadius: '6px'
                            },
                            rootHovered: { backgroundColor: '#4A2FC7' },
                            rootPressed: { backgroundColor: '#3B24A8' },
                            rootDisabled: { backgroundColor: '#e0e0e0', color: '#666666' },
                            label: { fontSize: '13px', fontWeight: 500 }
                        }}
                    />
                </div>
                </div>
            </div>
        );
    }
}

export default EntitySelection;
